import React from 'react'

export default function Text (props) {
  if (props.text !== '' && props.text !== undefined) {
    return (
      <p className={props.cls}>{props.text}</p>
    )
  }
  return null
}
